import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, onMounted } from 'vue';

import {
  dispatchGetCompany,
  dispatchUpdateCompany,
} from '@/store/main/actionsMain';
import { store } from '@/store/index';
import CompanyProfileEditForm from '@/views/pages/company/CompanyProfileEditForm.vue';
import { readAssertedCompany } from '@/store/main/getters';
import BaseButtonSubmit from '@/views/base/BaseButtonSubmit.vue';
import { usePermissionComposable } from '@/composables/usePermission';
import sharedMessages from '@/lib/shared-messages';
import { defineMessages } from '@/lib/i18n';
import { i18n } from '@/plugins/vue-i18n';
import CompanyContractView from './CompanyContractView.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyPage',
  setup(__props) {

const $t = i18n.t.bind(i18n);
const m = defineMessages({
  profile: '基本情報',
});

const menu = [m.profile];

const { hasPermission, PERMISSIONS: P } = usePermissionComposable();

const isValidForm = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const company = reactive({ ...readAssertedCompany(store) });

// Fetch latest company data including group_names on component mount
onMounted(async () => {
  await dispatchGetCompany(store, { companyId: company.uuid });
  const updatedCompany = readAssertedCompany(store);
  Object.assign(company, updatedCompany);
});

const updateCompany = async (): Promise<void> => {
  if (isLoading.value) {
    return;
  }
  isLoading.value = true;
  try {
    const form = {
      name: company.name,
      phone: company.phone,
    };
    await dispatchUpdateCompany(store, {
      params: {
        companyId: company.uuid,
      },
      payload: form,
    });
    await dispatchGetCompany(store, { companyId: company.uuid });

    // Update local company object with latest data from store
    const updatedCompany = readAssertedCompany(store);
    Object.assign(company, updatedCompany);
  } finally {
    isLoading.value = false;
  }
};

return { __sfc: true,$t, m, menu, hasPermission, P, isValidForm, isLoading, company, updateCompany, CompanyProfileEditForm, BaseButtonSubmit, sharedMessages, CompanyContractView }
}

})